/* istanbul ignore file */
import { Typography as MaterialTypography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { rem } from '../../theme';

import { StyledHeadingProperties } from './Heading.types';

export const StyledHeading = styled(MaterialTypography, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<StyledHeadingProperties>`
    ${({
        theme,
        $addPageContainerStyling,
        $color,
        $alignOnDesktop,
        $isLowercase,
    }) => `
        padding: ${
            $addPageContainerStyling
                ? theme.tggSpacing([0, rem(3)], [0, 7.5])
                : theme.tggSpacing(0, 0)
        };
        margin-right: ${theme.tggSpacing(0, 0)};
        margin-left: ${theme.tggSpacing(0, 0)};
        font-weight: ${theme.isRebranding('normal', '700')};
        color: ${
            $color ||
            theme.getRebrandingColor(
                theme.palette.primary.main,
                theme.palette.tgg.text.heading.main,
            )
        };
        ${$isLowercase ? 'text-transform: lowercase;' : ''}
        ${theme.breakpoints.up('desktop')} {
            padding: ${
                $addPageContainerStyling && $alignOnDesktop === 'left'
                    ? theme.tggSpacing([0, rem(3)], [0, 7.5])
                    : theme.tggSpacing(0, 0)
            };
            text-align: ${$alignOnDesktop || 'inherit'};
            ${$alignOnDesktop ? `width: 100%;` : ``}
            ${
                $alignOnDesktop === 'left'
                    ? `
                        max-width: 68.8rem; /*containerSmallWidth 62.8rem + padding 6rem*/
                        margin-inline: auto;
                    `
                    : ``
            };
        }
    `}
`;
